// src/app/page.tsx

import { fetchHeaderFooterHomeData } from "../lib/serverFetch";
import { getHomePageDataAction } from "../lib/actions/homePageAction";
import { extractLanguage } from "../lib/utils/domain";
import HomePageClient from "../components/home/HomePageClient";

export const dynamic = "force-dynamic";

export default async function Home() {
  const headerFooterHomeData = await fetchHeaderFooterHomeData();

  // homepage content (banner, program, discover, joinFreeClass, etc.)
  const homePageDataResponse = await getHomePageDataAction();

  const homePageData = homePageDataResponse.success && homePageDataResponse.data
    ? homePageDataResponse.data
    : { default: null, translated: null };

  return (
    <HomePageClient
      headerFooterHomeData={headerFooterHomeData}
      homePageData={homePageData}
    />
  );
}
